/**
 * Loading Component
 *
 * A professional loading spinner used as a Suspense fallback for lazy-loaded components.
 * Matches Coordi's branding and design system.
 */

interface LoadingProps {
  message?: string;
}

export const Loading = ({ message = "Loading..." }: LoadingProps) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-gray-900 dark:to-gray-800 flex items-center justify-center">
      <div className="text-center">
        <div className="relative">
          {/* Outer ring */}
          <div className="animate-spin rounded-full h-16 w-16 border-4 border-blue-200 dark:border-blue-900 mx-auto mb-4"></div>
          {/* Inner spinning ring */}
          <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-blue-600 dark:border-blue-400 mx-auto absolute top-0 left-1/2 transform -translate-x-1/2"></div>
        </div>
        <p className="text-gray-700 dark:text-gray-300 font-medium mt-4">{message}</p>
      </div>
    </div>
  );
};
